<template>
  <div class="org1" v-loading="loading">
    <div class="chart-container clearfix">
      <line-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="line"
        id="ALLChart"
        height="300px"
        width="50%"
        :lienList="lineChartData"
        tit="所有学术成果"
        v-loading="loading1"
      />
      <pie-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="pie"
        id="ALLPieChart"
        height="300px"
        width="40%"
        :chart-data="pieChartData"
        v-loading="loading1"
      />
    </div>
    <div class="chart-container clearfix" v-if="Jechart">
      <line-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="line"
        id="JChart"
        height="300px"
        width="50%"
        :lienList="JlineChartData"
        tit="中文核心论文"
        v-loading="loading2"
      />
      <pie-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="pie"
        id="JPieChart"
        height="300px"
        width="40%"
        :chart-data="JpieChartData"
        v-loading="loading2"
      />
    </div>
    <div class="chart-container clearfix" v-if="Iechart">
      <line-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="line"
        id="ENChart"
        height="300px"
        width="50%"
        :lienList="IlineChartData"
        tit="外文核心论文"
        v-loading="loading3"
      />
      <pie-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="pie"
        id="ENPieChart"
        height="300px"
        width="40%"
        :chart-data="IpieChartData"
        v-loading="loading3"
      />
    </div>
    <div class="chart-container clearfix" v-if="Pechart">
      <line-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="line"
        id="CNPatentChart"
        height="300px"
        width="50%"
        :lienList="PlineChartData"
        v-loading="loading4"
        tit="专利"
      />
      <pie-chart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        class="pie"
        id="CNPatentPieChart"
        height="300px"
        width="40%"
        :chart-data="PpieChartData"
        v-loading="loading4"
      />
    </div>
  </div>
</template>

<script>
import Chart from "@/components/Charts/LineMarker";
import LineChart from "@/components/Charts/LineChart";
import PieChart from "@/components/Charts/PieChart";
import { getRes } from "@/api/organization";

export default {
  name: "org1",
  props: {
    allData: Object,
    orgData: Object
  },
  watch: {
    allData(val) {
      if (Object.keys(this.allData).length) {
        this.getThreeChartData();
      }
      const countVal = [];
      const countYear = [];
      val.tops.topYears
        .sort((a, b) => {
          return a.name - b.name;
        })
        .forEach(item => {
          countVal.push(item.value);
          countYear.push(item.name);
        });
      this.pieChartData = this.allData.tops.topSubjects.slice(0, 10);
      this.lineChartData.countVal = countVal;
      this.lineChartData.countYear = countYear;
    }
  },
  components: {
    Chart,
    LineChart,
    PieChart
  },
  data() {
    return {
      loading: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      Iechart: true,
      Pechart: true,
      Jechart: true,
      lineChartData: {
        countVal: [],
        countYear: []
      },
      pieChartData: [],
      JlineChartData: {
        countVal: [],
        countYear: []
      },
      JpieChartData: [],
      IlineChartData: {
        countVal: [],
        countYear: []
      },
      IpieChartData: [],
      PlineChartData: {
        countVal: [],
        countYear: []
      },
      PpieChartData: []
    };
  },
  methods: {
    collationData(data, str) {
      const countVal = [];
      const countYear = [];
      data.topYears
        .sort((a, b) => {
          return a.name - b.name;
        })
        .forEach(item => {
          countVal.push(item.value);
          countYear.push(item.name);
        });
      if (str === "J") {
        this.JpieChartData = data.topSubjects.slice(0, 10);
        this.JlineChartData.countVal = countVal;
        this.JlineChartData.countYear = countYear;
        this.loading2 = false;
      }
      if (str === "I") {
        this.IpieChartData = data.topSubjects.slice(0, 10);
        this.IlineChartData.countVal = countVal;
        this.IlineChartData.countYear = countYear;
        localStorage.setItem(
          "IpieChartData",
          JSON.stringify(this.IpieChartData)
        );
        this.loading3 = false;
      }
      if (str === "P") {
        this.PpieChartData = data.topSubjects.slice(0, 10);
        localStorage.setItem(
          "PpieChartData",
          JSON.stringify(this.PpieChartData)
        );
        this.PlineChartData.countVal = countVal;
        this.PlineChartData.countYear = countYear;
        this.loading4 = false;
      }
      this.loading1 = false;
    },
    getThreeChartData() {
      const Jdata =
        this.orgData.nameAlt === null
          ? {
              name: [this.orgData.name],
              code: ["J"],
              year: [2010, 2018]
            }
          : {
              name: [
                this.orgData.name,
                this.orgData.nameAlt,
                this.orgData.shortNameAlt
              ],
              code: ["J"],
              year: [2010, 2018]
            };
      const Idata =
        this.orgData.nameAlt === null
          ? {
              name: [this.orgData.name],
              code: ["I"],
              year: [2010, 2018]
            }
          : {
              name: [
                this.orgData.name,
                this.orgData.nameAlt,
                this.orgData.shortNameAlt
              ],
              code: ["I"],
              year: [2010, 2018]
            };
      const Pdata =
        this.orgData.nameAlt === null
          ? {
              name: [this.orgData.name],
              code: ["P"],
              year: [2010, 2018]
            }
          : {
              name: [
                this.orgData.name,
                this.orgData.nameAlt,
                this.orgData.shortNameAlt
              ],
              code: ["P"],
              year: [2010, 2018]
            };
      this.loading1 = true;
      this.loading2 = true;
      this.loading3 = true;
      this.loading4 = true;
      this.loading = false;
      this.Jechart = true;
      this.Iechart = true;
      this.Pechart = true;
      getRes(Jdata)
        .then(res => {
          if (!res.data.data.length) {
            this.Jechart = false;
            this.loading2 = false;
            return;
          }
          this.collationData(res.data.tops, "J");
        })
        .catch(err => {
          console.log(err);
        });
      getRes(Idata)
        .then(res => {
          if (!res.data.data.length) {
            this.Iechart = false;
            this.loading3 = false;
            return;
          }
          this.collationData(res.data.tops, "I");
        })
        .catch(err => {
          console.log(err);
        });
      getRes(Pdata)
        .then(res => {
          if (!res.data.data.length) {
            this.Pechart = false;
            this.loading4 = false;
            return;
          }
          this.collationData(res.data.tops, "P");
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    if (Object.keys(this.allData).length) {
      this.getThreeChartData();
    } else {
      this.loading = true;
    }
  }
};
</script>

<style lang="scss">
.org1 {
  .chart-container {
    margin-bottom: 30px;
    .line {
      float: left;
    }
    .pie {
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/organization/Orgs/org1.vue